import { useMemo } from "react";
import { useCoursesLoaderData } from "./coursesLoader";

export default function useTermOptDeadline() {
  const { currentTerm } = useCoursesLoaderData();
  // Note: for terms with item level opt outs (IA only) optOutDeadlineDate is a derived value that equals
  // the opt out deadline for the course with the next opt out deadline
  // for term level opt out terms (FA and EA) this is the opt out deadline for the whole term
  const optDeadline = useMemo(
    () =>
      currentTerm?.optOutDeadlineDate
        ? new Date(currentTerm.optOutDeadlineDate)
        : undefined,
    [currentTerm?.optOutDeadlineDate]
  );
  const optWindowOpen = useMemo(
    () =>
      currentTerm?.active && optDeadline ? new Date() < optDeadline : false,
    [currentTerm?.active, optDeadline]
  );

  return useMemo(() => {
    return {
      optWindowOpen,
      optDeadline: currentTerm?.optOutDeadlineDate,
    };
  }, [optWindowOpen, currentTerm?.optOutDeadlineDate]);
}
